import {
  Patientportal_PortalAppointmentRequestFailureReason,
  useFindCurrentPortalUserLazyQuery,
  useRefreshPortalUserTokenMutation,
} from '@/generated/graphql';
import { dev } from '../apollo/ApolloSetup';

export const useHandleAppointmentRequestFailureReason = () => {
  const [refreshPortalUserToken] = useRefreshPortalUserTokenMutation();
  const [refreshUser] = useFindCurrentPortalUserLazyQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });

  const handleAppointmentRequestFailure = (
    failureReason: Patientportal_PortalAppointmentRequestFailureReason,
    {
      next,
      onError,
    }: {
      next?: () => void;
      onError?: () => void;
    },
  ) => {
    switch (failureReason) {
      case Patientportal_PortalAppointmentRequestFailureReason.PortalAppointmentRequestFailureReasonAccountVerifiedOnOtherDevice:
        refreshPortalUserToken().then(({ data, errors }) => {
          if (errors) {
            console.error(errors);
            onError?.();
          } else {
            const token = data?.refreshPortalUserToken?.token;
            if (token) {
              if (dev && typeof window !== 'undefined') {
                localStorage.setItem('token', token);
              }

              refreshUser().then(({ data, error }) => {
                if (error) {
                  console.error(error);
                  onError?.();
                } else if (data?.findCurrentPortalUser?.portalUser?.verified) {
                  next?.();
                } else {
                  console.error('User not verified after refresh');
                  onError?.();
                }
              });
            }
          }
        });
        break;
      default:
        console.error(`Appointment request failure reason ${failureReason} not implemented`);
    }
  };

  return [handleAppointmentRequestFailure];
};
